export const emoji = [
  {
    en: "grinning",
    cn: "笑",
    symbol: "😀"
  },
  {
    en: "disappointed_relieved",
    cn: "流汗",
    symbol: "😥"
  },
  {
    en: "heart_eyes",
    cn: "花痴",
    symbol: "😍"
  },
  {
    en: "fearful",
    cn: "难过",
    symbol: "😨"
  },
  {
    en: "sob",
    cn: "哭",
    symbol: "😭"
  },
  {
    en: "flushed",
    cn: "发呆",
    symbol: "😳"
  },
  {
    en: "mask",
    cn: "感冒",
    symbol: "😷"
  },
  {
    en: "sleeping",
    cn: "睡觉",
    symbol: "😴"
  },
  {
    en: "cry",
    cn: "流泪",
    symbol: "😢"
  },
  {
    en: "sweat_smile",
    cn: "心虚",
    symbol: "😅"
  },
  {
    en: "rage",
    cn: "愤怒",
    symbol: "😡"
  },
  {
    en: "joy",
    cn: "笑哭",
    symbol: "😂"
  },
  {
    en: "grin",
    cn: "嘻嘻",
    symbol: "😁"
  },
  {
    en: "hushed",
    cn: "吃惊",
    symbol: "😯"
  },
  {
    en: "persevere",
    cn: "折磨",
    symbol: "😣"
  },
  {
    en: "sweat",
    cn: "尴尬",
    symbol: "😓"
  },
  {
    en: "weary",
    cn: "痛苦",
    symbol: "😫"
  },
  {
    en: "triumph",
    cn: "生气",
    symbol: "😤"
  },
  {
    en: "blush",
    cn: "可爱",
    symbol: "😊"
  },
  {
    en: "stuck_out_tongue_winking_eye",
    cn: "鬼脸",
    symbol: "😜"
  },
  {
    en: "dizzy_face",
    cn: "衰",
    symbol: "😵"
  },
  {
    en: "laughing",
    cn: "爽",
    symbol: "😆"
  },
  {
    en: "sleepy",
    cn: "瞌睡",
    symbol: "😪"
  },
  {
    en: "cold_sweat",
    cn: "伤心",
    symbol: "😰"
  },
  {
    en: "expressionless",
    cn: "郁闷",
    symbol: "😑"
  },
  {
    en: "smiley",
    cn: "开心",
    symbol: "😃"
  },
  {
    en: "sunglasses",
    cn: "酷炫",
    symbol: "😎"
  },
  {
    en: "smile",
    cn: "大笑",
    symbol: "😄"
  },
  {
    en: "no_mouth",
    cn: "无语",
    symbol: "😶"
  },
  {
    en: "relieved",
    cn: "满意",
    symbol: "😌"
  },
  {
    en: "pensive",
    cn: "失落",
    symbol: "😔"
  },
  {
    en: "confounded",
    cn: "难忍",
    symbol: "😖"
  },
  {
    en: "scream",
    cn: "惊恐",
    symbol: "😱"
  },
  {
    en: "stuck_out_tongue",
    cn: "吐舌头",
    symbol: "😛"
  },
  {
    en: "kissing_heart",
    cn: "么么哒",
    symbol: "😘"
  },
  {
    en: "unamused",
    cn: "嫌弃",
    symbol: "😒"
  },
  {
    en: "smirk",
    cn: "嘚瑟",
    symbol: "😏"
  },
  {
    en: "confused",
    cn: "不甘",
    symbol: "😕"
  },
  {
    en: "innocent",
    cn: "天使微笑",
    symbol: "😇"
  },
  {
    en: "wink",
    cn: "眨眼",
    symbol: "😉"
  },
  {
    en: "stuck_out_tongue_closed_eyes",
    cn: "快乐",
    symbol: "😝"
  },
  {
    en: "anguished",
    cn: "失望",
    symbol: "😧"
  },
  {
    en: "pig",
    cn: "猪",
    symbol: "🐷"
  },
  {
    en: "joy_cat",
    cn: "狗狗笑",
    symbol: "😹"
  },
  {
    en: "scream_cat",
    cn: "狗狗惊呆",
    symbol: "🙀"
  },
  {
    en: "grimacing",
    cn: "呲牙",
    symbol: "😬"
  },
  {
    en: "kissing_closed_eyes",
    cn: "乐呵呵",
    symbol: "😚"
  },
  {
    en: "speak_no_evil",
    cn: "我不说",
    symbol: "🙊"
  },
  {
    en: "see_no_evil",
    cn: "我不看",
    symbol: "🙈"
  },
  {
    en: "hear_no_evil",
    cn: "我不听",
    symbol: "🙉"
  },
  {
    en: "beetle",
    cn: "爬虫",
    symbol: "🐞"
  },
  {
    en: "sunny",
    cn: "太阳",
    symbol: "🌞"
  },
  {
    en: "crescent_moon",
    cn: "晚安",
    symbol: "🌙"
  },
  {
    en: "bomb",
    cn: "炸弹",
    symbol: "💣"
  },
  {
    en: "alien",
    cn: "UFO",
    symbol: "👽"
  },
  {
    en: "bear",
    cn: "熊",
    symbol: "🐻"
  },
  {
    en: "cow",
    cn: "奶牛",
    symbol: "🐮"
  },
  {
    en: "tea",
    cn: "咖啡",
    symbol: "☕"
  },
  {
    en: "broken_heart",
    cn: "心碎",
    symbol: "💔"
  },
  {
    en: "sparkling_heart",
    cn: "爱心",
    symbol: "❤"
  },
  {
    en: "zan",
    cn: "强",
    symbol: "👍"
  },
  {
    en: "-1",
    cn: "弱",
    symbol: "👎"
  },
  {
    en: "clap",
    cn: "鼓掌",
    symbol: "👏"
  },
  {
    en: "wave",
    cn: "招手",
    symbol: "👋"
  },
  {
    en: "facepunch",
    cn: "握拳",
    symbol: "👊"
  },
  {
    en: "muscle",
    cn: "力量",
    symbol: "💪"
  },
  {
    en: "ok_hand",
    cn: "OK",
    symbol: "👌"
  },
  {
    en: "ghost",
    cn: "幽灵",
    symbol: "👻"
  },
  {
    en: "hibiscus",
    cn: "鲜花",
    symbol: "🌸"
  },
  {
    en: "pray",
    cn: "祈祷",
    symbol: "🙏"
  },
  {
    en: "kiss",
    cn: "飞吻",
    symbol: "💋"
  },
  {
    en: "imp",
    cn: "暴怒",
    symbol: "👿"
  },
  {
    en: "smiling_imp",
    cn: "恶魔",
    symbol: "😈"
  },
  {
    en: "rocket",
    cn: "火箭",
    symbol: "🚀"
  },
  {
    en: "100",
    cn: "一百分",
    symbol: "💯"
  },
  {
    en: "hankey",
    cn: "便便",
    symbol: "💩"
  },
  {
    en: "lollipop",
    cn: "棒棒糖",
    symbol: "🍭"
  },
  {
    en: "moneybag",
    cn: "钱钱钱",
    symbol: "💰"
  },
  {
    en: "fire",
    cn: "火",
    symbol: "🔥"
  },
  {
    en: "footprints",
    cn: "脚丫",
    symbol: "👣"
  }
];

const symbolReg =
  "(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])";

var emojis = [],
  emojiMap = {};
for (var i = 0; i < emoji.length; i++) {
  var e = emoji[i];
  emojis.push(e.en);
  emojiMap[e.symbol] = e.en;
}
var Reg = new RegExp(symbolReg, "g");
const replaceColon = function(value) {
  value = (value || "").replace(/<div>|<\/div>|<br>|&nbsp;/g, "");
  var text = value.replace(Reg, function(match) {
    if (value) {
      var en = emojiMap[match];
      if (en) {
        var url = require("@/assets/images/emoji/" + en + ".png");
        return "<img src='" + url + "' alt=':" + en + ":'/>";
      } else {
        return match;
      }
    } else {
      return match;
    }
  });
  return text;
};

export { symbolReg, replaceColon };
